const esUS= {
    login: {
      title: 'Iniciar sesión',
      sign_in_btn: 'Iniciar sesión'
    },
    bar: {
        logout: 'Cerrar sesión',
        languages: 'Idiomas',
        settings: 'Abrir configuración'
    },
    language: {
      name: 'Español (Estados Unidos)',
    },
    attributePage: {
        title: 'Cambios en los atributos',
        viewChanges: 'Ver cambios',
        dateTime: 'Fecha',
        notificationType: 'Tipo de notificación',
        notificationValue: 'Valor de notificación',
        oldValue: 'Valor anterior',
        newValue: 'Nuevo valor',
        accept: 'Aceptar',
        reject: 'Rechazar',
    },
    Home: 'Inicio',
    load: 'Realizando la carga inicial...',
    Requested: "Solicitado",
    Viewed: "Visto",
    Executing: "Ejecutando",
    Completed: "Completado",
    Expired: "Vencido",
    Cancelled: "Cancelado",
    Error: "Error",
    Rejected: "Rechazado",
    error: 'Algo salió mal; intente de nuevo más tarde.',
    displayname: 'Nombre de pantalla',
    givenname: 'Nombre',
    surname: 'Apellido',
    email: 'Correo electrónico',
    mail: 'Correo electrónico',
    name: 'Nombre',
    firstname: 'Nombre',
    lastname: 'Apellido',
    footer_copyright: 'Todos los derechos reservados.'
  };
  
  export default esUS;
  